import { Themes } from '../../styles/theme/theme-schema';

const useTheme = theme => {
  return Themes['dark'];
  //   return theme ? Themes[theme] : Themes['dark'];
};

export default useTheme;
